import { useQuery } from "@tanstack/react-query";
import { FORM30_ENDPOINTS } from "../../services/network/endpoints";
import { getForm30 } from "../../services/network/form30-api";

/**
 * Хук для получения данных формы 30
 * @param sectorId ID сектора/региона
 * @param year Год отчета
 * @param enabled Флаг, определяющий, нужно ли выполнять запрос
 */
export function useFetchForm30(
    sectorId: string | null,
    year: number,
    enabled: boolean = true
) {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: [FORM30_ENDPOINTS.FETCH, sectorId, year],
        queryFn: () => getForm30(sectorId!, year),
        enabled: enabled && Boolean(sectorId && year),
        staleTime: 5 * 60 * 1000, // 5 минут
    });

    return {
        form30Data: data?.data,
        form30Error: error,
        form30IsLoading: isLoading,
        refetchForm30: refetch,
    };
}
